import { writable, derived } from 'svelte/store';

/** Store for your data. 
This assumes the data you're pulling back will be an array.
If it's going to be an object, default this to an empty object.
**/
export const apiData = writable({});

/** Data transformation.
For our use case, we only care about the some info, not the other information.
Here, we'll create a derived store to hold the only required data.
**/
export const UserData = derived(apiData, ($apiData) => {
    // TODO you can filter some unused data here

    if ($apiData.user) {
        $apiData = {
            ...$apiData.user,
            userBanTime: $apiData.userBanTime,
            isUserBanned: $apiData.userBanTime != null,
            isDeviceIdBanned: $apiData.isDeviceIdBanned,
            isSocialBanned: $apiData.isSocialBanned
        };
    }

    delete $apiData.powerupRewardBag;
    delete $apiData.friendRequestsReceived;
    delete $apiData.questSlots;
    delete $apiData.eventQuestSlots;
    delete $apiData.tournamentsHistory;
    delete $apiData.gameInvitation;
    delete $apiData.friendStats;
    delete $apiData.abClass;
    delete $apiData.currentMaxLostCards;
    delete $apiData.currentLostCards;
    delete $apiData.friendChatHistory;
    delete $apiData.friendChatHistorySeen;
    delete $apiData.refreshToken;
    delete $apiData.timedQuests;
    delete $apiData.timedQuestsQueue;
    delete $apiData.clanTournamentsHistory;
    delete $apiData.fortuneWheel;
    delete $apiData.userDailyDeals;

    return $apiData;
    //   return {};
});

